var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShopColor = function SvgShopColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 80,
    fill: "none",
    viewBox: "0 0 74 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00ADC6",
    d: "M18.542 74.895c17.396 10.044 39.64 4.084 49.684-13.312s4.083-39.64-13.313-49.684S15.273 7.816 5.23 25.212c-10.044 17.396-4.084 39.64 13.312 49.683",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#071C26",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.743,
    d: "M58.22 46.408V66.6l-43.874-.006-.092-20.186M9.044 35.335l5.21-15.307h44.293l5.862 15.307"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00ADC6",
    d: "M21.993 35.335a7.287 7.287 0 0 1-7.286 7.022 7.29 7.29 0 0 1-7.289-7.022zM36.648 35.335a7.287 7.287 0 0 1-7.286 7.022 7.287 7.287 0 0 1-7.285-7.022h14.574zM51.303 35.335a7.287 7.287 0 0 1-7.285 7.022 7.287 7.287 0 0 1-7.286-7.022h14.575zM65.959 35.335a7.287 7.287 0 0 1-7.286 7.022 7.287 7.287 0 0 1-7.285-7.022h14.574zM52.685 61.064v-7.328a7.328 7.328 0 0 0-14.656 0v7.328zM28.16 55.049l4.098-1.137c.29-.081.293-.492 0-.576l-4.084-1.176a.3.3 0 0 1-.206-.209l-1.136-4.097c-.082-.29-.492-.293-.577 0l-1.175 4.084a.3.3 0 0 1-.209.206l-4.097 1.136c-.29.081-.293.492 0 .577l4.084 1.175a.3.3 0 0 1 .205.209l1.137 4.097c.082.29.492.293.576 0l1.176-4.084a.3.3 0 0 1 .209-.205"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "5a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h73.277v80H0z"
  })))));
};
export default SvgShopColor;